import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {
    const location = useLocation();
    const prevPathnameRef = useRef(location.pathname);
    const prevSearchRef = useRef(location.search);

    useEffect(() => {
        const isOnlyOneScreen = !!(location.state && location.state.onlyOneScreen);
        const isDashboardIframe = window.name === 'tap-dashboard-iframe';
        const isAuth = location.search.includes('auth=');
        const isInIframe = window.self !== window.top;
        const hasLocationChanged =
            location.pathname !== prevPathnameRef.current || location.search !== prevSearchRef.current;

        if ((hasLocationChanged || isAuth) && !isOnlyOneScreen && !isDashboardIframe) {
            const tapPageElement = document.getElementById('tap-page');

            if (tapPageElement) {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });

                if (isInIframe) {
                    try {
                        if (window.parent && window.parent !== window) {
                            const postData = JSON.stringify({
                                type: 'safariOrIOSOffset',
                                offsetTop: 0,
                                block: 'start',
                            });
                            window.parent.postMessage(postData, '*');
                        } else if (window.parentIFrame && typeof window.parentIFrame.scrollToOffset === 'function') {
                            const elementRect = tapPageElement.getBoundingClientRect();
                            const elementTop = window.pageYOffset + elementRect.top;
                            window.parentIFrame.scrollToOffset(0, elementTop);
                        }
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.error(error);
                    }
                }
            }

            prevPathnameRef.current = location.pathname;
            prevSearchRef.current = location.search;
        }
    }, [location.pathname, location.search, location.state]);

    return children;
};

export default ScrollToTop;
